import http, { httpGet } from '@/utils/http';

export default {
    save: data => {
        return http({url:'/api/admin/v1/store/save',data,tip:true,loading:true}).then(r => r);
    },
    delete: data => {
        return http({url:'/api/admin/v1/store/delete',data,tip:true,loading:true}).then(r => r);
    },
    list: data => {
        return http({url:'/api/admin/v1/store/list',data}).then(r => r);
    },
    listAll: () => {
        return http({url:'/api/admin/v1/store/listAll'}).then(r => r);
    },
    // 更新门店库位
    updateLocations: data => {
        return http({url:'/api/admin/v1/store/updateLocations',data,tip:true,loading:true}).then(r => r);
    },
    // 同步门店
    syncStores: (data) => {
        return http({ url: '/api/admin/v1/store/syncStores', data }).then(r => r);
    },
    // 查询同步进度
    getSyncProgress: (taskId) => {
        return httpGet({ 
            url: '/api/admin/v1/store/getSyncProgress', 
            params: { task_id: taskId } 
        }).then(r => r);
    },
}